/* eslint-disable */
import { EventEmitter } from 'events';
import moment from 'moment';
import {
  CrontabExecStatus,
  CrontabFrequency,
  ICrontabRecord,
  RepoCrontabStatus,
  TIME_LEN,
  TIME_PLACEHOLDER,
} from '../../../model';

export class Crontab<T> extends EventEmitter {
  private _crontabID = '';

  // 任务状态
  private _status: RepoCrontabStatus = RepoCrontabStatus.Running;

  /**
   * @field time
   * @description
   *  time接收一个数组，每项取值说明：[年, 月, 日, 时, 分, 秒]
   *  计算方式，会匹配每项值，判断当前时间是否以匹配任务设定时间，如果一致则执行任务回调
   *
   * @param
   *  年：大于等于今年
   *  月：1-12
   *  日：1-31之间
   *  时：0-24
   *  分：0-60
   *  秒：0-60
   *  “*”星号表示缺省值，不会计算
   *
   * @example
   *  1、[*, *, *, 12, *]，则表示12点执行任务
   *  2、[*, *, 5, 22, *]，则表示5号晚上22点执行任务
   *  3、[*, 4, 5, 22, *]，则表示4月5号晚上22点执行任务
   */
  private _time: ReadonlyArray<ReadonlyArray<string>> = [];

  // 执行频率，interval一直间隔执行, number: 设定执行次数，需要大于0，最少执行1次
  private _frequency: CrontabFrequency = 'interval';

  /**
   * @field taskInstance
   * @description 需要执行任务的实例，会调用任务实例的trigger方法。所以每个任务实例必须有trigger方法
   * @example
   * export class ExampleTaskCrontab {
   *  public trigger(crontab: Crontab<ExampleTaskCrontab>) {
   *    //
   *  }
   * }
   */
  private _taskInstance: T | null = null;

  public constructor(
    crontabID: string,
    status: RepoCrontabStatus,
    time: ReadonlyArray<string>,
    frequency: CrontabFrequency,
    taskInstance: T
  ) {
    super();
    this._crontabID = crontabID;
    this._status = status;
    this._time = this.verifyTime(this.formatComplementTime(time));
    this._frequency = frequency;
    this._taskInstance = taskInstance;
  }
  public get crontabID() {
    return this._crontabID;
  }

  public get status() {
    return this._status;
  }

  public get time() {
    return this._time;
  }

  public get frequency() {
    return this._frequency;
  }

  public get taskInstance() {
    return this._taskInstance;
  }

  public destroy() {
    this._taskInstance = null;
  }

  public getRecord = (opt: {
    id?: string;
    status?: CrontabExecStatus;
    log?: string;
  }): ICrontabRecord => {
    return {
      status: opt.status || CrontabExecStatus.Failed,
      timeEnd: this.getTimer(),
      log: opt.log || '',
    };
  };

  private getTimer = () => {
    return moment().format('YYYY-MM-DD HH:mm:ss ms');
  };

  private formatComplementTime(
    times: ReadonlyArray<string>
  ): ReadonlyArray<ReadonlyArray<string>> {
    const complement = (time: string) => {
      const times = time.split(':');
      const len = times.length;
      const complement = TIME_LEN - len;
      for (let i = 0; i < complement; i++) {
        times.unshift(TIME_PLACEHOLDER);
      }
      return times;
    };

    const returnTimes: Array<ReadonlyArray<string>> = [];
    times.forEach((item) => {
      returnTimes.push(complement(item));
    });
    return returnTimes;
  }

  private verifyTime(
    times: ReadonlyArray<ReadonlyArray<string>>
  ): ReadonlyArray<ReadonlyArray<string>> {
    for (let i = 0; i < times.length; i++) {
      const time = times[i];
      if (time.length !== TIME_LEN) {
        this.emit('Error', `Crontab time setting error, ${time}`, this);
        throw `Crontab time setting error, ${time}`;
      }
    }
    return times;
  }
}
